export enum UserRole {
    Admin = "admin",
    Sales = "sales"
}